import { createTheme } from '@mui/material/styles';

import breakpoints from 'utils/breakpoints';
import { getColor } from 'utils/colors';
import mixins from 'utils/mixins';
import { remCalc } from 'utils/remCalc';

const theme = createTheme({
	breakpoints: breakpoints,
	mixins: mixins,
});

export const styles = {};

export const overrides = {
	'@keyframes fadeIn': {
		'0%': { opacity: 0 },
		'40%': { opacity: 0 },
		'100%': { opacity: 1 }
	},
	'.featureCard__card': {
		position: 'relative',
		height: remCalc(309),
		borderRadius: 0,
		overflow: 'hidden',
		boxShadow: 'none',
		backgroundColor: getColor('ivory', 800),
		'&:focus-within': {
			'.featureCard__media': {
				transform: 'scale(1.22)',
			},
			'.featureCard__overlay': {
				background: 'rgba(0, 0, 0, 0.2)',
			},
			'.featureCard__content': {
				gap: 0,
			},
			'.featureCard__cardSubtitle': {
				opacity: 0,
				maxHeight: 0,
				transform: 'translateY(-8px)',
			},
			'.featureCard__cardTitle': {
				fontSize: remCalc(49),
				lineHeight: remCalc(54),
				letterSpacing: remCalc(0.5),
			},
		},
		'@media (hover: hover) and (pointer: fine)': {
			'&:hover': {
				'.featureCard__media': {
					transform: 'scale(1.22)',
				},
				'.featureCard__overlay': {
					background: 'rgba(0, 0, 0, 0.2)',
				},
				'.featureCard__content': {
					gap: 0,
				},
				'.featureCard__cardSubtitle': {
					opacity: 0,
					maxHeight: 0,
					transform: 'translateY(-8px)',
				},
				'.featureCard__cardTitle': {
					fontSize: remCalc(49),
					lineHeight: remCalc(54),
					letterSpacing: remCalc(0.5),
				},
			},
		},
		'&.animate': {
			'.featureCard__cardTitle': {
				animation: 'fadeIn .6s linear',
			}
		}
	},

	'.featureCard__media': {
		position: 'absolute',
		inset: 0,
		backgroundRepeat: 'no-repeat',
		backgroundSize: 'cover',
		backgroundPosition: 'center',
		transition: 'transform .35s ease',
	},

	'.featureCard__overlay': {
		position: 'absolute',
		inset: 0,
		background: 'rgba(0, 0, 0, 0.3)',
		transition: 'background-color .2s',
	},

	'.featureCard__actionArea': {
		position: 'relative',
		zIndex: 1,
		height: '100%',
		display: 'flex',
		alignItems: 'flex-end',
		textDecoration: 'none',
		color: getColor('white'),

		'&:hover': {
			textDecoration: 'none',
		},

		'&:focus-visible': {
			outline: `${remCalc(2)} solid ${getColor('blue', 400)}`,
			outlineOffset: `-${remCalc(2)}`,
		},
	},

	'.featureCard__content': {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-end',
		gap: remCalc(20),
		padding: remCalc(48),
		height: '100%',
		transition: 'gap .35s ease',
	},

	'.featureCard__cardSubtitle': {
		color: getColor('white'),
		margin: 0,
		maxHeight: remCalc(32),
		overflow: 'hidden',
		opacity: 1,
		transform: 'translateY(0)',
		letterSpacing: remCalc(-0.25),
		textTransform: 'uppercase',
		transition: 'opacity var(--transition-duration) ease, transform var(--transition-duration) ease, max-height var(--transition-duration) ease .2s',
	},

	'.featureCard__cardTitle': {
		color: getColor('white'),
		margin: 0,
		letterSpacing: remCalc(-0.32),
		textTransform: 'capitalize',
		fontSize: remCalc(32),
		lineHeight: remCalc(40),
		transition: 'font-size .1s ease .15s, line-height var(--transition-duration) ease .15s, letter-spacing var(--transition-duration) ease .15s',
		// transition: 'font-size var(--transition-duration) ease, line-height var(--transition-duration) ease, letter-spacing var(--transition-duration) ease',
		// transition: 'font-size var(--transition-duration) ease, line-height var(--transition-duration) ease, letter-spacing var(--transition-duration) ease',
	},

	[theme.breakpoints.down('md')]: {

		'.featureCard__cardTitle': {
			fontSize: remCalc(39),
			lineHeight: remCalc(47),
		},

		'.featureCard__card': {
			'@media (hover: hover) and (pointer: fine)': {
				'&:hover': {
					'.cardSlider__media': {
						transform: 'scale(1.22)',
					},
					'.featureCard__cardTitle': {
						fontSize: remCalc(39),
						lineHeight: remCalc(47),
					},
				},
				'&:focus-within': {
					'.cardSlider__media': {
						transform: 'scale(1.22)',
					},
				},
			},
		},
	},

	'@media (prefers-reduced-motion: reduce)': {
		'.featureCard__media, .featureCard__overlay, .featureCard__content, .featureCard__cardSubtitle, .featureCard__cardTitle': {
			transition: 'none',
		},
	},
};

export default styles;
